import { render, staticRenderFns } from "./TemperatureMeasureRadioButton.vue?vue&type=template&id=89079718&scoped=true&"
import script from "./TemperatureMeasureRadioButton.vue?vue&type=script&lang=js&"
export * from "./TemperatureMeasureRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./TemperatureMeasureRadioButton.vue?vue&type=style&index=0&id=89079718&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89079718",
  null
  
)

export default component.exports